<template>
	<div class="note">
		<div class="noteButton" @click="showNote" v-if="isShowNoteIcon">
			<i class="iconfont icon-xuexibiji"></i>
			<div class="text">学习笔记</div>
		</div>
		<div class="noteMain" :class="{on: isShowNote}">
			<div class="noteMainT">
				<h3>学习笔记</h3>
				<i class="iconfont icon-dengluzhuceguanbi" @click="closeNote"></i>
			</div>
			<div class="form">
				<div class="list">
					<div class="listL">
						<i>*</i>
						<span>笔记标题：</span>
					</div>
					<div class="listR">
						<el-input placeholder="请输入标题" v-model="formData.title" size="small" maxlength="50" clearable>
						</el-input>
					</div>
				</div>
				<div class="list">
					<div class="listL">
						<i>*</i>
						<span>笔记分类：</span>
					</div>
					<div class="listR">
						<el-select v-model="formData.categoryId" placeholder="请选择分类" size="small" style="flex: 1">
							<el-option v-for="item in categoryList" :key="item.categoryId" :label="item.categoryName"
								:value="item.categoryId">
							</el-option>
						</el-select>
						<el-button class="defaultButton" type="primary" size="small"
							@click="createCategory">添加分类</el-button>
					</div>
				</div>
				<div class="list" style="align-items: normal;">
					<div class="listL" style="margin-top: 5px">
						<span>自定义标签：</span>
					</div>
					<div class="listR">
						<el-input type="textarea" placeholder="请输入自定义标签 （多个标签请用，隔开）" v-model="formData.labels"
							size="small" maxlength="50" clearable resize="none">
						</el-input>
					</div>
				</div>
			</div>
			<div class="h4"><i>*</i>笔记内容：</div>
			<vue-editor ref="editor" :editor-toolbar="customToolbar" v-model="formData.content"
				:use-custom-image-handler="true" @image-added="handleImageAdded" />
			<div class="foot">
				<el-button @click="closeNote">取 消</el-button>
				<el-button class="defaultButton" type="primary" :loading="saveLoading"
					@click="saveNote">{{saveLoading ? '保存中' : '保存笔记'}}</el-button>
			</div>
		</div>

		<el-dialog title="创建分类" :visible.sync="isCreateCategory" width="600px" top="20vh" :modal-append-to-body="false">
			<el-form ref="createFolderForm" :model="createFolderForm" :rules="createFolderRules" label-width="100px">
				<el-form-item label="分类名称：" prop="categoryName">
					<el-input v-model="createFolderForm.categoryName" placeholder="请输入分类名称" size="medium" maxlength="30"
						clearable />
				</el-form-item>
				<el-form-item label="颜色：">
					<el-color-picker v-model="createFolderForm.color" :predefine="predefineColors"
						@active-change="colorChange"></el-color-picker>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isCreateCategory = false">取 消</el-button>
				<el-button type="primary" @click="confirmCreateFolder">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		VueEditor
	} from 'vue2-editor'
	import axios from 'axios'

	import {
		EventBus
	} from '@/utils/eventBus';

	// 深拷贝工具函数
	const deepClone = (obj) => {
		if (obj === null || typeof obj !== 'object') return obj;

		if (obj instanceof Date) return new Date(obj);
		if (obj instanceof RegExp) return new RegExp(obj);

		const cloneObj = Array.isArray(obj) ? [] : {};

		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				cloneObj[key] = deepClone(obj[key]);
			}
		}

		return cloneObj;
	}

	export default {
		name: 'takeNotes',
		components: {
			VueEditor
		},
		data() {
			return {
				isShowNoteIcon: true,
				isShowNote: false,
				formData: {
					title: '',
					categoryId: '',
					labels: '',
					content: ''
				},
				categoryList: [],
				customToolbar: [
					["bold", "italic", "underline"],
					[{
						align: ""
					}, {
						align: "center"
					}, {
						align: "right"
					}],
					[{
						list: "ordered"
					}, {
						list: "bullet"
					}],
					["image"]
				],
				// 保存初始的 formData 结构用于重置
				initialFormData: {
					title: '',
					categoryId: '',
					labels: '',
					content: ''
				},

				createFolderForm: {
					categoryName: '',
					color: ''
				},
				isCreateCategory: false,
				createFolderRules: {
					categoryName: [{
						required: true,
						message: '请输入分类名称',
						trigger: 'change'
					}]
				},
				predefineColors: [
					'#FF383C', '#F56C6C', '#F15FB6', '#FF7D00', '#FFCC00', '#ACCB00', '#00C788', '#00C3D0',
					'#0D68FF', '#6155F5', '#BA55F5', '#C46B3B', '#D53784', '#7D8037', '#B56363', '#2C7117',
					'#004984', '#5F146E', '#666666', '#CCCCCC'
				],
				headers: {
					Authorization: 'Bearer ' + localStorage.getItem('token'),
					'Content-Type': 'multipart/form-data'
				},

				saveLoading: false,

				isNoteEdit: false
			}
		},

		watch: {
			$route(route) {
				// 判断路由路径是否包含 /student/
				if (route.path.includes('/student/')) {
					this.isShowNoteIcon = true;
				} else {
					this.isShowNoteIcon = false;
					// 如果不在学生路由下，也隐藏笔记弹窗
					this.isShowNote = false;
				}
			}
		},

		mounted() {
			// 保存初始状态
			this.initialFormData = deepClone(this.formData);
			// 初始化图片粘贴监听
			this.initImagePasteListener();

			EventBus.$on('rootOpenNoteAdd', this.rootOpenNoteAddHandle);
			EventBus.$on('rootOpenNoteEdit', this.rootOpenNoteEditHandle);
		},
		beforeDestroy() {
			// 移除事件监听
			if (this.editorElement) {
				this.editorElement.removeEventListener('paste', this.handlePaste);
			}

			EventBus.$off('rootOpenNoteAdd', this.rootOpenNoteAddHandle);
			EventBus.$off('rootOpenNoteEdit', this.rootOpenNoteEditHandle);
		},

		methods: {
			rootOpenNoteAddHandle(data) {
				this.isNoteEdit = false;
				this.isShowNote = true;
				this.resetFormData();
				this.getNotesCategoryCountList();
				this.formData.categoryId = data.categoryId
			},

			rootOpenNoteEditHandle(data) {
				this.isNoteEdit = true;
				this.getNotesCategoryCountList();
				this.formData = {
					...data
				}
				this.isShowNote = true;
			},

			// 显示笔记弹窗
			showNote() {
				this.isShowNote = true;
				// 重置表单数据
				this.resetFormData();
				// 重新获取分类列表（确保数据最新）
				this.getNotesCategoryCountList();
			},

			// 关闭笔记弹窗
			closeNote() {
				this.isShowNote = false;
				// 可以在这里重置表单，或者在下次打开时重置
			},

			// 重置表单数据
			resetFormData() {
				// 使用深拷贝重置 formData 到初始状态
				this.formData = deepClone(this.initialFormData);
			},

			createCategory() {
				const customCategoryCount = this.categoryList.length > 0 ? this.categoryList.length - 1 : 0;
				if (customCategoryCount >= 20) {
					this.$message.warning('笔记分类最多只能创建20个');
					return;
				}
				this.createFolderForm = {
					categoryName: '',
					color: ''
				};
				this.isCreateCategory = true
			},

			confirmCreateFolder() {
				const customCategoryCount = this.categoryList.length > 0 ? this.categoryList.length - 1 : 0;
				if (customCategoryCount >= 20) {
					this.$message.warning('笔记分类最多只能创建20个');
					return;
				}
				this.$refs.createFolderForm.validate((valid) => {
					if (valid) {

						this.$request.post('/userApi/addUserNotesCategory', this.createFolderForm).then(
							res => {
								if (res.succeeded) {
									this.$message.success('创建成功')
									this.formData.categoryId = res.data
									this.isCreateCategory = false
									this.getNotesCategoryCountList()

									this.$root.$emit('rootNoteCreateSaveEmit', {
										categoryId: res.data
									});
								} else {
									this.$message.error(res.errors)
								}
							})
					}
				})
			},

			// 保存笔记
			saveNote() {
				// 这里可以添加表单验证逻辑
				if (!this.validateForm()) {
					return;
				}

				// 深拷贝 formData，避免后续操作影响当前数据
				const submitData = deepClone(this.formData);

				var url = this.isNoteEdit ? '/userApi/updateUserNotes' : '/userApi/addUserNotes'

				this.$request.post(url, submitData).then(res => {
					if (res.succeeded) {

						this.$root.$emit('rootNoteCreateSaveEmit', {
							categoryId: submitData.categoryId
						});

						// 保存成功后关闭弹窗
						this.closeNote();
						// 可以添加保存成功的提示
						this.$message.success('笔记保存成功');
					} else {
						this.$message.error(res.errors);
					}
				}).catch(error => {
					console.error(error);
					this.$message.error(error);
				})
			},

			// 表单验证
			validateForm() {
				if (!this.formData.title.trim()) {
					this.$message.warning('请输入笔记标题');
					return false;
				}

				if (this.formData.categoryId === '' || this.formData.categoryId === null || this.formData.categoryId ===
					undefined) {
					this.$message.warning('请选择笔记分类');
					return false;
				}

				if (!this.formData.content.trim()) {
					this.$message.warning('请输入笔记内容');
					return false;
				}

				return true;
			},

			// 获取分类列表
			getNotesCategoryCountList() {
				this.$request.get('/userApi/getNotesCategoryCountList').then(res => {
					this.categoryList = res.data;
					// 如果有分类数据，设置默认选中第一个
					if (res.data && res.data.length > 0 && !this.formData.categoryId) {
						this.formData.categoryId = res.data[0].categoryId;
					}
				}).catch(error => {
					console.error('获取分类列表失败:', error);
					this.$message.error('获取分类列表失败');
				})
			},

			// 初始化图片粘贴监听
			initImagePasteListener() {
				this.$nextTick(() => {
					const editor = this.$refs.editor;
					if (editor) {
						// 获取编辑器的DOM元素
						this.editorElement = editor.quill.root;
						// 添加粘贴事件监听
						this.editorElement.addEventListener('paste', this.handlePaste);
					}
				});
			},

			// 处理粘贴事件
			async handlePaste(event) {
				const clipboardData = event.clipboardData || window.clipboardData;
				if (!clipboardData) return;

				const items = clipboardData.items;
				let hasImage = false;

				// 遍历剪贴板中的项目
				for (let i = 0; i < items.length; i++) {
					if (items[i].type.indexOf('image') !== -1) {
						hasImage = true; // eslint-disable-line no-unused-vars
						const file = items[i].getAsFile();
						if (file) {
							event.preventDefault(); // 阻止默认粘贴行为

							try {
								// 上传图片并获取URL
								const imageUrl = await this.uploadImage(file, 'paste');

								if (imageUrl) {
									// 获取编辑器实例
									const quill = this.$refs.editor.quill;
									const range = quill.getSelection();
									const position = range ? range.index : quill.getLength();

									// 插入图片到编辑器
									quill.insertEmbed(position, 'image', imageUrl);
									quill.setSelection(position + 1);

									// 更新内容
									this.formData.content = quill.root.innerHTML;
								}
							} catch (error) {
								console.error('粘贴图片失败:', error);
								this.$message.error('图片粘贴失败');
							}

							break;
						}
					}
				}
			},

			// 处理vue2-editor的图片添加事件 - 关键修复！！！
			async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
				console.log('handleImageAdded被调用:', {
					file,
					cursorLocation
				});

				try {
					// 上传图片并获取URL
					const imageUrl = await this.uploadImage(file, 'toolbar');

					if (imageUrl) {
						// 重要：使用Editor.insertEmbed插入图片到指定位置
						Editor.insertEmbed(cursorLocation, 'image', imageUrl);

						// 可选：将光标移动到图片后面
						Editor.setSelection(cursorLocation + 1);

						// 重要：调用resetUploader重置上传器
						if (resetUploader) {
							resetUploader();
						}

						return true;
					}
				} catch (error) {
					console.error('图片插入失败:', error);
					this.$message.error('图片插入失败');
				}

				return false;
			},

			// 上传图片到服务器 - 修复返回数据处理
			async uploadImage(file, source = 'unknown') { // eslint-disable-line no-unused-vars
				try {
					// 验证文件类型
					if (!file.type.startsWith('image/')) {
						this.$message.warning('请上传图片文件');
						return null;
					}

					// 验证文件大小（限制5MB）
					const maxSize = 5 * 1024 * 1024; // 5MB
					if (file.size > maxSize) {
						this.$message.warning('图片大小不能超过5MB');
						return null;
					}

					// 显示全局加载动画
					if (this.$loading && this.$loading.show) {
						this.$loading.show();
					}

					// 创建FormData
					const formData = new FormData();
					formData.append('file', file);

					// 上传图片
					console.log('开始上传图片...');
					const response = await axios.post(
						`${this.$rootUrl}/api/system/uploadFile/99`,
						formData, {
							headers: this.headers,
							timeout: 30000 // 30秒超时
						}
					);

					console.log('上传响应:', response.data);

					if (response.status === 200 && response.data) {
						// 根据你提供的接口返回结构，response.data 是一个对象
						// 包含 fileName 和 url 字段
						let imageUrl = response.data.data.url;
						console.log(response)
						// 检查是否获取到了url
						if (!imageUrl) {
							console.error('接口返回的数据中没有找到url字段:', response.data);
							throw new Error('无法获取图片URL');
						}

						// 确保imageUrl是字符串
						if (typeof imageUrl !== 'string') {
							console.warn('imageUrl不是字符串，尝试转换为字符串:', imageUrl);
							imageUrl = String(imageUrl);
						}

						// 确保返回的是完整的URL
						if (imageUrl && !imageUrl.startsWith('http')) {
							// 如果返回的是相对路径，拼接完整URL
							if (imageUrl.startsWith('/')) {
								imageUrl = `https://file.wenms.com${imageUrl}`;
							} else {
								imageUrl = `https://file.wenms.com/${imageUrl}`;
							}
						}

						// 隐藏加载动画
						if (this.$loading && this.$loading.hide) {
							this.$loading.hide();
						}

						console.log('上传成功，图片URL:', imageUrl);
						this.$message.success('图片上传成功');
						return imageUrl;
					} else {
						throw new Error('上传失败，服务器返回异常');
					}
				} catch (error) {
					// 隐藏加载动画
					if (this.$loading && this.$loading.hide) {
						this.$loading.hide();
					}

					console.error('图片上传失败:', error);

					// 根据错误类型给出不同提示
					let errorMessage = '上传失败，请稍后重试';

					if (error.response) {
						// 服务器返回了错误状态码
						if (error.response.status === 401) {
							errorMessage = '未授权，请重新登录';
						} else if (error.response.status === 413) {
							errorMessage = '文件太大，请压缩后上传';
						} else {
							errorMessage = `上传失败: ${error.response.status}`;
						}
					} else if (error.request) {
						// 请求已发出但没有收到响应
						errorMessage = '网络错误，请检查网络连接';
					} else if (error.message.includes('timeout')) {
						errorMessage = '上传超时，请稍后重试';
					} else {
						errorMessage = error.message || '上传失败，请稍后重试';
					}

					this.$message.error(errorMessage);
					return null;
				}
			},

			colorChange(e) {
				this.createFolderForm.color = e
			}
		}
	}
</script>

<style lang="scss" scoped>
	.noteButton {
		color: #8C8C8C;
		cursor: pointer;
		text-align: center;
		letter-spacing: 0;
		font-size: 12px;
		transition: all 0.3s;
		transform: scale(0.8);

		.icon-xuexibiji {
			background: linear-gradient(135deg, #4BCAFF 0%, #1A71FF 100%);
			background-clip: text;
			color: transparent;
			font-size: 40px;
		}

		&:hover {
			color: #0D68FF;
		}
	}

	.noteMain {
		position: fixed;
		width: 704px;
		right: 0;
		top: 0;
		height: 100vh;
		box-sizing: border-box;
		background-color: #FFFFFF;
		box-shadow: 0px 1px 7px 1px rgba(13, 104, 255, 0.35);
		transition: all 0.3s ease-in-out;
		transform: translate(200%, 0);
		padding: 20px;

		&.on {
			transform: translate(0, 0);
		}
	}

	.noteMainT {
		display: flex;
		justify-content: space-between;
		font-size: 15px;
		line-height: normal;

		.icon-dengluzhuceguanbi {
			font-size: 20px;
			cursor: pointer;
		}
	}

	.form {
		display: flex;
		flex-direction: column;
		row-gap: 20px;
		margin: 20px 0;

		.list {
			display: flex;
			align-items: center;

			.listL {
				font-size: 14px;
				width: 100px;
				text-align: right;

				i {
					color: #FF383C;
				}
			}

			.listR {
				flex: 1;
				display: flex;
				align-items: center;
				column-gap: 10px;
			}
		}
	}

	.h4 {
		margin-bottom: 10px;
		font-size: 14px;
		font-weight: normal;

		i {
			color: #FF383C;
		}
	}

	.foot {
		display: flex;
		justify-content: center;
		padding: 20px 0;

		.el-button {
			padding: 9px 50px;
		}

		.defaultButton {
			margin-left: 20px;
		}
	}

	::v-deep .quillWrapper {
		border: 1px solid #EBEEF6;
		border-radius: 4px;
		overflow: hidden;

		.ql-toolbar.ql-snow {
			border: 0;
			border-bottom: 1px solid #EBEEF6;
			background: #F3F4F6;
			padding: 8px 8px;
			display: flex;
			align-items: center;
			column-gap: 20px;

			.ql-formats {
				margin: 0;
				padding-left: 20px;
				position: relative;

				&:before {
					content: '';
					position: absolute;
					top: 15%;
					left: 0;
					bottom: 15%;
					width: 1px;
					background: #dbdbdb;
					border-radius: 1px;
				}

				&:nth-child(1):before {
					content: none;
					padding-left: 0;
				}

				&:nth-child(1) {
					padding-left: 0;
				}

				svg {
					width: 18px !important;
					height: 18px !important;
				}
			}
		}

		.ql-editor {
			font-size: 14px !important;
			height: calc(100vh - 395px);

			// 确保图片在编辑器中正确显示
			img {
				max-width: 100%;
				height: auto;
				margin: 10px 0;
			}
		}

		.ql-container.ql-snow {
			border: 0;
		}

		// 修复图片上传按钮样式
		.ql-toolbar .ql-formats button.ql-image {
			position: relative;

			&::after {
				content: '';
				font-size: 12px;
				color: #666;
				margin-left: 5px;
			}
		}
	}
</style>